import Container from "@client/content/Containers/container";
import { Form } from "@client/content/controls";
import { getContainerProps, getEntityRef, getRootContainerProps } from "@client/content/lib/helper";
import FormStyleProvider from "@client/content/Providers/FormStyle/container";
import { type RootContainerProps } from "@client/content/types";
import { type FormFieldInfo } from "@client/controls/Form/component";
import * as React from "react";
import FormButton from "./FormButton/container";
import Modal from "./Modal/container";

import "./style.less";

export type MapProps = RootContainerProps & {
  fields: FormFieldInfo[];
  formStyle: React.CSSProperties;
  status: string;
};

export type ActionProps = {};

type Props = ActionProps & MapProps;
export default (props: Props) => (
  <Container className="wsc_content_contact_form" {...getContainerProps(props)}>
    <div className="wsc_contact_form">
      <Form
        {...getRootContainerProps(props)}
        fields={props.fields}
        Button={FormButton}
        buttonProps={getRootContainerProps(props)}
        resetOnSubmit
        style={props.formStyle}
      />

      <FormStyleProvider {...getEntityRef(props)}>
        <Modal {...getRootContainerProps(props)} />
      </FormStyleProvider>
    </div>
  </Container>
);
